import React, { Component } from "react";
import styles from "./GIFLanding.module.scss";
import { bounceIn, Button2, SnapSection } from "../../components";
import { ReactComponent as DoubleArrows } from "../../assets/SVGs/double-chevron-right.svg";
import { ReactComponent as BeatBread } from "../../assets/SVGs/logos/beatBread-logo.svg";
import { ReactComponent as GIF } from "../../assets/SVGs/logos/GIF-light.svg";
import { ReactComponent as AIM } from "../../assets/partnerLogos/AIM-Light.svg";
import { ReactComponent as IMPALA } from "../../assets/partnerLogos/Impala-light.svg";
import { ReactComponent as WIN } from "../../assets/partnerLogos/Win-light.svg";
import { GIFFORM } from "../../routes/constants";
import { motion } from "motion/react";

class GIFLanding extends Component {
  render() {
    return (
      <>
        <SnapSection className={styles.landing}>
          <motion.div className={styles.landing_container} {...bounceIn}>
            <GIF className={styles.landing_logos}
              alt="GIF logo"
            />
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>$100M For Independent Labels and Distributors</h1>
              <Button2 className={styles.mainButton} to={`${GIFFORM}?label_id=gif`} light>
                <p>Apply for Funding</p> <DoubleArrows />
              </Button2>
            </div>
            <div className={styles.partnersContainer}>
              <p>In conjunction with:</p>
              <div className={styles.gifPartners}>
                <img
                  src={require("../../assets/partnerLogos/aim-ireland.png")}
                  alt="aim ireland logo"
                />
                <AIM alt="aim logo" />
                <BeatBread alt="beatbread logo" />
                <IMPALA alt="impala logo" />
                <WIN alt="win logo" />
              </div>
            </div>
          </motion.div>
        </SnapSection>
      </>
    );
  }
}

export default GIFLanding;
